let osgKey = null;
if(process.env.REACT_APP_ONE_SIGNAL_APP_ID){
    osgKey = process.env.REACT_APP_ONE_SIGNAL_APP_ID;
}

const OSG_APP_KEY = osgKey;

export { OSG_APP_KEY };